import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({

  waitingList: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: 5,
    marginTop: 8,
    padding: 8,
    '& p': {
      margin: 0
    },
    '& .MuiChip-root': {
      margin: '8px 8px 0 0'
    }
  },

  rattachesList: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: 5,
    margin: '8px 0',
    '& p': {
      padding: '16px 8px',
      margin: 0
    },

    '& .MuiTableContainer-root': {
      maxHeight: 150,
    },

    '& thead > tr > td:last-child': {
      width: 1
    },
    '& tbody > tr > td:last-child': {
      width: 1
    },



  },

  ajout: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: 5,
    padding: 8,
    position: 'relative',

    '& p': {
      marginTop: 0
    },
    '& > div': {
      display: 'flex',
      gap: 8,


      [theme.breakpoints.up('650')]: {
        position: 'absolute',
        bottom: 8,
        left: 8,
        right: 8,
      },
      [theme.breakpoints.down('650')]: {
        flexDirection: 'column',
        position: 'relative',
        '& > button': {
          width: '100%!important',
        }
      },
      
    },

    [theme.breakpoints.down('450')]: {
      marginTop: 8,
    },

  },

  line: {
    [theme.breakpoints.up('450')]: {
      display: 'flex',
      gap: 8,
      '& > *': {
        width: '100%',
        margin: 0
      }
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  cancel: {
    color: theme.palette.danger.main
  },
  radio: {
    display: 'flex',
    flexDirection: 'row!important',
    alignItems: 'center'
  },
  columns: {
    display: 'flex',
    gap: 16,
    '& > div': {
      width: '100%',
    },
    [theme.breakpoints.down('600')]: {
      flexDirection: 'column',
    },
  },
  wrap: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    '& > .MuiFormControl-root': {
      width: 'calc(50% - 16px)',
      margin: '0!important',
      '& > .MuiFormControl-root': {
        width: '100%',
      }
    },
    [theme.breakpoints.down('600')]: {
      flexDirection: 'column',
      '& > .MuiFormControl-root': {
        width: '100%',
      },
    },
  }

}))